import React, { ComponentProps, createContext, useContext } from 'react';

import { ElementTypes } from '../util/types';

const DebugVisibleContext = createContext<boolean>(false);

export function DebugVisibleContextProvider({
  children,
  value,
}: React.PropsWithChildren<{ value: boolean }>) {
  return <DebugVisibleContext.Provider value={value}>{children}</DebugVisibleContext.Provider>;
}

export function useDebugVisibleContext() {
  return useContext(DebugVisibleContext);
}

export function DebugWrapper<E extends ElementTypes>({
  element,
  children,
  ...props
}: React.PropsWithChildren<
  { element?: E; className?: string } & Omit<ComponentProps<E>, 'element'>
>) {
  const Element = element ?? 'div';
  const debugVisible = useDebugVisibleContext();
  return debugVisible ?
      <Element style={{ outline: '5px solid #f0f' }} {...props}>
        {children}
      </Element>
    : null;
}
